import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './ErrorBoundary';
import { adoptProjection } from './render/projection';
import './styles.css';

// Settle the projection before anything renders. The sprite sheet is baked in
// whichever tile ratio is in force at the time and an upright window wants a
// different one, so choosing here is the difference between one bake and two.
adoptProjection(window.innerWidth, window.innerHeight);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
